<template>
  <default-button :label="label"
                  :icon="icon"
                  :disable="disable"
                  :loading="loading"
                  custom-style="margin-bottom: 0"
                  v-on="$listeners" />
</template>

<script>
import DefaultButton from '@/components/styled/DefaultButton';

export default {
  name: 'DialogButton',
  components: { DefaultButton },
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: String,
    disable: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
